export const formatValue = (value) => {
    if (typeof value == 'boolean') return value ? 'Si' : 'No'
    if (typeof value == 'string') return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase()
    return !value ? '-' : value
}